//import React from 'react';
import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';
import { ChallengesItem } from '~/components/ui/challenges-item';
import { FriendsItem } from '~/components/ui/friends-item';
import { UserItem } from '~/components/ui/user-item';
//import { classic } from '~/themes/classic';

type IProps = {
  onChallengeClick?: () => void;
  withoutActions?: boolean;
  onFriendClick?: () => void;
  hasNotifications?: boolean;
  setNotifications?: Dispatch<SetStateAction<boolean>> | undefined;

  onChallengeClickWithNotifications?: () => void;

  isChallengeNotifications?: boolean;
};

type TProps = IProps; // & ReturnType<typeof mapStateToProps> & TRootAction

export function Menu({
  onChallengeClick,
  withoutActions,
  onFriendClick,
  hasNotifications,
  setNotifications,
  isChallengeNotifications,
  onChallengeClickWithNotifications,
}: TProps) {
  const navigate = useNavigate();
  return (
    <Container>
      <UserItem onClick={() => navigate('/logout')} />
      {!withoutActions && (
        <SDiv>
          <ChallengesItem
            onChallengeClick={onChallengeClick}
            hasNotifications={hasNotifications}
            setNotifications={setNotifications}
            onChallengeClickWithNotifications={
              onChallengeClickWithNotifications
            }
            isNotifications={isChallengeNotifications}
          />
          <FriendsItem onClick={onFriendClick} />
        </SDiv>
      )}
    </Container>
  );
}

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  user-select: none;
  width: 100%;
`;

const SDiv = styled.div`
  align-items: center;
  display: flex;
  & > *:first-of-type {
    margin-right: 10px;
  }
`;
